import { TrendingUp } from "lucide-react"
import { useTranslation } from "react-i18next"

import type { CreatorLeaderboardClimb } from "@/types/creator-leaderboard"

/**
 * OKS-519 — §13 "you climbed N spots" banner.
 *
 * Celebratory pill shown above the podium when the viewer rose week-over-
 * week (`climb` non-null). CSS-only fade/slide entrance (UX Spec §4 — no
 * JS animation). The magnitude lives here (per-row deltas are direction-
 * only, PRD Open Q3).
 */
interface YouClimbedBannerProps {
  climb: CreatorLeaderboardClimb
}

export function YouClimbedBanner({ climb }: YouClimbedBannerProps) {
  const { t } = useTranslation()

  return (
    <div
      data-testid="creator-leaderboard-climbed"
      role="status"
      className="motion-safe:animate-in motion-safe:fade-in motion-safe:slide-in-from-top-2 flex items-center justify-center gap-2 rounded-xl bg-orange-100 px-4 py-2 text-sm font-semibold text-orange-900 dark:bg-orange-950 dark:text-orange-100"
    >
      <TrendingUp className="size-4 shrink-0" aria-hidden="true" />
      <span>{t("leaderboard.creator.climbed", { count: climb.spots })}</span>
    </div>
  )
}
